import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { useHomeContext } from '../../context'

const Hero = () => {
  const { t, heroIllustration } = useHomeContext()

  return (
    <Box sx={{ position: 'relative', zIndex: 10, pt: 4 }}>
      {/* Light bulb icon */}
      <Typography sx={{ fontSize: 24, mb: 1, position: 'relative', zIndex: 2 }}>💡🌟</Typography>

      {/* Title */}
      <Typography
        component="h1"
        sx={{
          fontFamily: 'Merriweather, serif',
          fontWeight: 900,
          fontSize: 32,
          lineHeight: '43px',
          letterSpacing: '1px',
          color: '#1C1C1E',
          position: 'relative',
          zIndex: 2,
        }}
      >
        {t('landing.title')}
        <br />
        {t('landing.titleLine2')}
        <br />
        {t('landing.titleLine3')}{' '}
        <Box component="span" sx={{ color: '#501BC0', fontStyle: 'italic' }}>
          {t('landing.titleHighlight')}
        </Box>
      </Typography>

      {/* Illustration */}
      <Box
        sx={{
          position: 'absolute',
          top: -20,
          right: -30,
          width: 200,
          height: 260,
          zIndex: 1,
        }}
      >
        <Box
          component="img"
          src={heroIllustration}
          alt="Person with tablet"
          sx={{ width: '100%', height: '100%', objectFit: 'contain' }}
        />
      </Box>
    </Box>
  )
}

export default Hero
